<template>
  <div class="cancel-account-page container">
    <p>פעולה זו תפסיק את גביית התשלומים עבור המנוי שלך</p>
    <p>הגישה לסרטונים הכלולים במנוי זה תיחסם לאחר סיום תקופת התשלום שלך.</p>
    <p class="last">חשבון המשתמש שלך לא ימחק וניתן יהיה לחדש את המנוי דרך שם המשתמש שלך</p>

      <form :action="action" method="POST">
        <router-link :to="{name: 'home'}" class="yoga-btn">
      התחרטתי, קח אותי בחזרה לעמוד הבית</router-link>

        <input type="hidden" name="username" :value="$store.state.user.email">
        <input type="hidden" name="action" value="cancel">
        <input type="submit" value="בטל מנוי" class="yoga-btn-beige">
      </form>
  </div>
</template>

<script>
export default {
  name: `Cancel`,

  computed: {
    action() {
      return `${process.env.VUE_APP_API_POST_CANCEL}`;
    }
  }
};
</script>

<style lang="scss">
.cancel-account-page {
  padding-top: 50px;
  min-height: 800px;

  .last {
    margin-bottom: 30px;
  }

  .yoga-btn {
    margin-left: 20px;
    font-size: 18px;
  }
}
</style>
